import * as React from "react";
import { IProduct } from "../../types/product";
// import { IButtonAddToBasketProps } from "~/components/button-add-to-basket/button-add-to-basket";
import CtaButton from "../cta-button/cta-button";
// import ProductPrice, { IProductPriceProps } from "../product-price/product-price";
import ShowMore from "../show-more/show-more";
import { pushImpressionViewTrackingEvent, pushClickTrackingEvent } from "~/utils/tracking-utils";
import { useInView } from "react-intersection-observer";
import Tag from "../tag/tag";
import ProductAuthors from "../product-authors/product-authors";
// import InfoSection from "../info-section/info-section";
// import ProductDiscountSplash from "../product-discount-splash/product-discount-splash";
import ProductImage from "../product-image/product-image";
import ContentSection from "../content-section/content-section";

export interface IProductTeaserProps {
    product: IProduct;
    splashLabel?: string;
    splashText?: string;
    ctaLink?: string;
    autogeneratedCtaLink?: string;
    productPriceAddToBasketLabel?: string;
    enableShowMoreDescription?: boolean;
    showMoreButton?: string;
    showLessButton?: string;
    featuredLabel?: string;
    anchorId?: string;
    hasNoMarginTop?: boolean;
    hasNoMarginBottom?: boolean;
}

const ProductTeaser: React.FC<IProductTeaserProps> = ({
    product,
    // productPriceAddToBasketLabel,
    // primaryPriceLabel,
    // secondaryPriceLabel,
    // addToBasketWebApiUrl,
    splashLabel,
    splashText,
    featuredLabel,
    ctaLink,
    autogeneratedCtaLink,
    enableShowMoreDescription,
    showMoreButton,
    showLessButton,
    ...props
}) => {
    const {
        title,
        authors,
        description,
        imageFallbackSrc,
        imageSrcSet,
        productId,
        // priceType,
        // primaryPrice,
        // secondaryPrice,
        url
        // materialType,
        // discount
    } = product;
    const baseClass = "product-teaser";

    const image = imageFallbackSrc && imageSrcSet && (
        <ProductImage fallbackSrc={imageFallbackSrc} srcSet={imageSrcSet} sizes="240px" alt={title} />
    );

    const trackingParams = {
        productId,
        title,
        trackingList: "Product Teaser",
        trackingPosition: 1
    };

    const [ref, inView] = useInView({
        triggerOnce: true
    });

    React.useEffect(() => {
        if (inView) {
            pushImpressionViewTrackingEvent([trackingParams]);
        }
    }, [inView]);

    const clickTrackingEvent = () => pushClickTrackingEvent(trackingParams);

    return (
        <ContentSection className={baseClass} type="full" {...props}>
            <div className={`${baseClass}__inner`} ref={ref}>
                <div className={`${baseClass}__image-section-wrapper`}>
                    <div className={`${baseClass}__image-section`}>
                        {imageFallbackSrc && url && (
                            <a href={url} onClick={clickTrackingEvent}>
                                {image}
                            </a>
                        )}
                        {imageFallbackSrc && !url && image}
                        {(splashLabel || splashText) && (
                            <div className={`${baseClass}__splash-wrapper`}>
                                <div className={`${baseClass}__splash`}>
                                    {splashLabel && (
                                        <div
                                            className={`${baseClass}__splash-label`}
                                            dangerouslySetInnerHTML={{ __html: splashLabel }}
                                        />
                                    )}
                                    {splashText && (
                                        <div
                                            className={`${baseClass}__splash-text`}
                                            dangerouslySetInnerHTML={{ __html: splashText }}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                        {/* {discount && <ProductDiscountSplash discount={discount} />} */}
                    </div>
                </div>
                <div className={`${baseClass}__content-wrapper`}>
                    {featuredLabel ? (
                        <Tag className={`${baseClass}__featured-tag`}>{featuredLabel}</Tag>
                    ) : null}

                    {url ? (
                        <h2 className={`${baseClass}__title h2-style`}>
                            <a className="reset-a" href={url} onClick={clickTrackingEvent}>
                                {title}
                            </a>
                        </h2>
                    ) : (
                        <h2 className={`${baseClass}__title h2-style`}>{title}</h2>
                    )}

                    <ProductAuthors
                        className={`${baseClass}__product-authors`}
                        authors={authors}
                        maxLines={2}
                    />

                    {/* {materialType && <div className={`${baseClass}__material-type`}>{materialType}</div>} */}
                    {description && (
                        <>
                            {enableShowMoreDescription && showMoreButton && showLessButton ? (
                                <ShowMore
                                    className={`${baseClass}__rich-text-show-more-wrapper`}
                                    minHeight={140}
                                    btnLabelShowMore={showMoreButton}
                                    btnLabelShowLess={showLessButton}
                                >
                                    <div
                                        className="content-rich-text"
                                        dangerouslySetInnerHTML={{
                                            __html: description
                                        }}
                                    />
                                </ShowMore>
                            ) : (
                                <div
                                    className={`${baseClass}__rich-text content-rich-text`}
                                    dangerouslySetInnerHTML={{ __html: description }}
                                />
                            )}
                        </>
                    )}

                    {ctaLink && <CtaButton link={ctaLink} isLarge />}
                    {autogeneratedCtaLink && <CtaButton link={autogeneratedCtaLink} isLarge />}
                    {/* <div className={`${baseClass}__price-wrapper`}> */}
                    {/* <ProductPrice
                            primaryPriceLabel={primaryPriceLabel}
                            secondaryPriceLabel={secondaryPriceLabel}
                            priceType={priceType}
                            primaryPrice={primaryPrice}
                            secondaryPrice={secondaryPrice}
                        >
                            {ctaLink ? (
                                <CtaButton link={ctaLink} isLarge />
                            ) : (
                                <>
                                    {addToBasketWebApiUrl && (
                                        <ButtonAddToBasket
                                            addToBasketWebApiUrl={addToBasketWebApiUrl}
                                            productId={productId}
                                            trackingList="Product Teaser"
                                            isLarge
                                        >
                                            {productPriceAddToBasketLabel}
                                        </ButtonAddToBasket>
                                    )}
                                </>
                            )}
                        </ProductPrice> */}
                    {/* </div> */}
                    {/* {product.stockStatusLabel && (
                        <InfoSection iconId="32_information" label={product.stockStatusLabel} />
                    )}
                    {product.deliveryLabel && (
                        <InfoSection iconId="32_truck-in-motion" label={product.deliveryLabel} />
                    )} */}
                </div>
            </div>
        </ContentSection>
    );
};

export default ProductTeaser;
